module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/K40JM2/tc-custom/9781638294900.jpg?1685328099464",
      "alt": "This image is the cover for the book Adventures of Jane"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Adventures of Jane\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Jane was always going on adventures as a child. In "), _c('em', [_vm._v("Adventures of Jane,")]), _vm._v(" she literally goes to the edge and back with little separation between her and landing in the deep dark scary unknown. Never failing Jane, Scott, her brother, saves the day, at least until they arrive back at grandma and gramp’s house."), _c('span', {
    staticStyle: {
      "font-family": "\"Open Sans Condensed\", sans-serif",
      "font-size": "12px"
    }
  })]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jane Waltz\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }), _c('p', [_c('span', {
    staticStyle: {
      "font-family": "'Open Sans Condensed',sans-serif"
    }
  }, [_vm._v("Jane had an exciting childhood with parents holding top secret jobs and a brother that liked to take Jane with him on adventures. Today, Jane lives in Northern Kentucky with her husband, John who also held many top-secret clearances, and their children, Sydney, Noel, Olivia, and Delilah. ")])]), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 71
// module chunks = 0